import v1 from './1';
import v2 from './2';

const module = {
    versions: Object.freeze([v1, v2]),
};

export default Object.freeze(module);
